export default __webpack_public_path__ + "static/member1-4fe86336ea1b2c62d8aa097ca664ce9e.jpg";